import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const AddLabHead = () => {
  const {id}=useParams()
  const navigate=useNavigate()
  const location=useLocation()
  const [choice, setChoice] = useState("existing");
  const [users, setUsers] = useState([]); 
  const [departments, setDepartments] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedDepartment,setSelectedDepartment] = useState("")
  const [loading,setLoading]=useState(false)
  // console.log("The dean departments are:",departments)
  const fetchDeanDepartments = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/marketplace/university/department/dean/`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        }
      );
      setDepartments(res?.data || []);
    } catch (error) {
      console.log("Error while getting profiles", error);
      setDepartments([]);
    }
  };

  useEffect(() => {
    fetchDeanDepartments();
  }, []);
  
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/marketplace/university/user-profiles/`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
              "x-api-key": process.env.REACT_APP_X_API_KEY,
            },
          }
        );

        // console.log("Users API Response:", res.data);

        // ✅ handle paginated OR normal response
        setUsers(res.data.results || res.data || []);
      } catch (error) {
        console.log("Error while getting profiles", error);
        setUsers([]);
      }
    };

    fetchUsers();
  }, []);

  const handleAddDean = async (e) => {
    e.preventDefault()
    if(!selectedDepartment) return alert('Department id is required')
    if(!selectedUser) return alert('Profile id is requried')
    try {
      setLoading(true)
      const res = await axios.post(
        `${BASE_URL}/marketplace/university/labhead/`,
        {
          profile_id: selectedUser, // ✅ send selected user id
          department_id:selectedDepartment,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        }
      );

      // console.log("Dean Created:", res.data);
      alert("Lab head created successfully");
      navigate(`/marketplace/${id}/dean/labheads`)
      setSelectedUser("");
    } catch (error) {
      alert(error.response?.data?.error);
      console.log("Error while creating dean", error?.response);
    }finally{
      setLoading(false)
    }
  };

  return (
    <>
     {/* Buttons */}
<div className="flex items-center justify-center gap-4 mb-6">
  <button
    type="button"
    onClick={() => setChoice("existing")}
    className={`px-5 py-2.5 text-sm font-medium rounded-xl transition-all duration-200 ${
      choice === "existing"
        ? "bg-[#0f6abf] text-white shadow-sm"
        : "bg-white text-gray-700 border border-gray-300 hover:border-gray-400"
    }`}
  >
    Select Lab Head From Existing Users
  </button>

  <button
    type="button"
    onClick={() => setChoice("manual")}
    className={`px-5 py-2.5 text-sm font-medium rounded-xl transition-all duration-200 ${
      choice === "manual"
        ? "bg-[#0f6abf] text-white shadow-sm"
        : "bg-white text-gray-700 border border-gray-300 hover:border-gray-400"
    }`}
  >
    Add Lab Head User Manually
  </button>
</div>

{/* Existing User Selection */}
{choice === "existing" && (
  <form
    onSubmit={handleAddDean}
    className="bg-white rounded-2xl border border-gray-200 p-6 max-w-3xl mx-auto"
  >
      <div className="mb-6">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <label className="text-sm font-semibold text-gray-700">
          Select Lab Department
        </label>
      </div>

      <select
        value={selectedDepartment}
        onChange={(e) => setSelectedDepartment(e.target.value)}
        className="w-full px-4 py-3 border border-gray-300 rounded-xl"
        required
      >
        <option value="">-- Select Department --</option>

        {departments.map((department) => (
          <option
            key={department?.id}
            value={department?.id}
          >
            {department?.name}
          </option>
        ))}
      </select>
    </div>

    <div className="mb-6">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <label className="text-sm font-semibold text-gray-700">
          Select Lab Head
        </label>
      </div>

      <select
        value={selectedUser}
        onChange={(e) => setSelectedUser(e.target.value)}
        className="w-full px-4 py-3 border border-gray-300 rounded-xl"
        required
      >
        <option value="">-- Select User --</option>

        {users.map((user) => (
          <option
            key={user.profile_id || user.id}
            value={user.profile_id || user.id}
          >
            {user.name || user.full_name} ({user.email})
          </option>
        ))}
      </select>
    </div>

    <button
      type="submit"
      disabled={loading}
      className="mt-6 w-full bg-[#0f6abf] text-white py-3 rounded-xl"
    >
      {loading ? "Creating Lab Head..." : "Add Lab Head"}
    </button>
  </form>
)}


      {choice === "manual" && <></>}
    </>
  );
};

export default AddLabHead;
